import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#151317] pt-12 relative" style={{ 
      borderTop: '1px solid',
      borderImageSource: 'linear-gradient(90deg, #000000 0%, #7A7A7F 52.4%, #000000 100%)',
      borderImageSlice: '1',
    }}>
      <div className="mx-auto relative z-10">
        <div className="grid !grid-cols-3 md:!grid-cols-6 !gap-[60px] mb-12 px-14 items-start">
          {/* Logo and Description */}
          <div className="col-span-3">
            <div className="flex items-center mb-6">
              <img src="/images/logo.svg" alt="InterstellarMap Logo" className="w-auto h-[40px] md:h-[2.5vw] mr-2" />
            </div>

            <h2 class="text-[31px] md:text-[2.5vw] font-normal leading-tight">Every Moment<br/>Has its Sky.</h2>
            <p className="text-gray-300 mt-8">We help you capture the stars from the night<br/>that changed everything.</p>
          </div>
          {/* Create Section */}
          <div className="mt-[2.5vw] pt-0 md:pt-6 !col-span-3 md:!col-span-1">
            <h3 className="text-white text-md mb-6">
            Useful Links
            </h3>
            <nav className="space-y-3">
              <Link to="/about" className="block text-gray-300 hover:text-accent transition-colors">
                About us
              </Link>
              <a className="block text-gray-300 hover:text-accent transition-colors cursor-pointer"
                onClick={() => document.dispatchEvent(new CustomEvent('open-login-modal'))}
              >
                Log In
                </a>
            </nav>
          </div>

          {/* Company Section */}
          <div className="mt-[2.5vw] pt-0 md:pt-6 !col-span-3 md:!col-span-1">
          <h3 className="text-white text-md mb-6">
          Payment Systems
            </h3>
            <nav>
              <img src="/images/visa-icon.png" alt="Visa" className="w-[60px] h-auto mb-7" />
              <img src="/images/mastercard-icon.png" alt="Mastercard" className="w-[146px] h-auto mb-5" />
              <img src="/images/3DS-icon.png" alt="3DS" className="w-[62px] h-auto" /> 
            </nav>
          </div>

          {/* Legal Section */}
          <div className="mt-[2.5vw] pt-0 md:pt-6 !col-span-3 md:!col-span-1">
          <h3 className="text-white text-md mb-6">
          Contact
            </h3>
            <nav>
            <p>Placeholder Street 28,<br/>23456 City, Country</p>
            </nav>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="text-center bg-[#A961ED] h-auto md:h-[100px] py-6 px-6 gap-2 md:py-0 flex flex-wrap md:flex-nowrap justify-center md:justify-end items-center column-gap-4 md:pr-14 text-[14px] md:text-[16px] text-black">
          <Link to="/terms" className="text-black hover:text-white transition-colors mr-4">Terms and Conditions</Link>
          <Link to="/privacy" className="text-black hover:text-white transition-colors mr-4">Privacy Policy</Link>
          <Link to="/refund" className="text-black hover:text-white transition-colors mr-4">Refund Policy</Link>
          <Link to="/cookies" className="text-black hover:text-white transition-colors mr-4">Cookies Policy</Link>
          <span>Copyright © 2025</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 